export default "/assets/images/smiling-girl.56626283e52afee2.webp";